import React from 'react';
import { IS_TENANT } from 'tenant/config';

const t = {
  m: 'm',
};

const HeightCell = ({ height, convert = true }) => {
  if (typeof height === 'undefined' || IS_TENANT) {
    return null;
  }

  return (
    <>
      {height / (convert ? 100 : 1)}
      {t.m}
    </>
  );
};

export default HeightCell;
